import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceReviewCyclesPage from "@/pages/admin/PerformanceReviewCyclesPage";

export const Route = createFileRoute("/_admin/admin/performance/cycles/")({
  head: () => pageHead("Admin · Performance · Cycles", "AKIVA admin · performance · cycles portal.", "/admin/performance/cycles", true),
  component: PerformanceReviewCyclesPage,
});
